<template>
  <div :id="`${machineTipKey}`" class="machine-tip" :style="`width: ${width}px; height: ${height}px;`">
    <!-- 机器 -->
    <div class="machine">
      <div class="machine-box">
        <!-- 机器名称 -->
        <div class="machine-title" style="height: 38px; padding: 0 8px 0 10px; font-size: 16px;">
          <div class="name">
            {{ machineData.name }}
          </div>
        </div>
        <!-- 机器数值 -->
        <div class="machine-cont" style="height: calc(100% - 38px); padding: 10px 8px;">
          <!-- 信息行 -->
          <div class="info-line" v-for="v in machineData.list" :key="v.key">
            <div class="infoName" style="width: 135px; height: 32px; font-size: 14px; line-height: 32px;">{{ v.name }}
            </div>
            <div class="infoNum" style="width: 135px; height: 32px; font-size: 14px; line-height: 32px;">{{ v.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    machineList: {
      type: Object
    },
    machineKey: {
      type: String
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 180,
    }
  },
  data() {
    return {
      // 数据
      machineData: {
        name: "",
        list: [],
      },
      // 机器的key
      machineTipKey: "",
    };
  },
  mounted() {
    this.machineTipKey = this.machineKey;
    this.machineData = this.machineList;
  },
  methods: {
  },
  watch: {
    machineList(n) {
      this.machineData = n;
    },
  }
};
</script>
<style lang="less" scoped>
.machine-tip {
  display: flex;

  .machine {
    width: 100%;
    height: 100%;
    display: flex;

    .machine-box {
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg,
          rgba(113, 118, 136, 0.5) 0%,
          rgba(0, 0, 0, 0.1) 100%);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
      border: 1px solid;
      border-image: linear-gradient(180deg,
          rgba(151, 151, 151, 0),
          rgba(200, 200, 200, 1)) 1 1;

      // 机器名称
      .machine-title {
        width: calc(100% - 0);
        margin: -1px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        color: #ffffff;
        background: url("./images/machineTip-bg.png") no-repeat 0 0;
        background-size: 100% 100%;

        .name {
          display: flex;
          align-items: center;
        }

        .check {
          height: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;

          span {
            width: 24px;
            height: 14px;
            margin-top: 3px;
            margin-left: 8px;
            background: url("./images/right-arrow.png") no-repeat 0 center;
            background-size: 100% 100%;
          }
        }
      }

      // 机器数值
      .machine-cont {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-line {
          display: flex;
          justify-content: space-between;

          .infoName {
            background: linear-gradient(90deg,
                rgba(113, 118, 136, 0.3) 0%,
                rgba(113, 118, 136, 0.2) 100%);
            border: 1px solid;
            border-image: linear-gradient(270deg,
                rgba(151, 151, 151, 0.2),
                rgba(200, 200, 200, 1)) 1 1;
            backdrop-filter: blur(3px);
            font-weight: 500;
            color: #ffffff;
            text-align: center;
          }

          .infoNum {
            border: 1px solid;
            padding-left: 16px;
            border-image: linear-gradient(96deg,
                rgba(200, 200, 200, 1),
                rgba(151, 151, 151, 0)) 1 1;
            font-weight: 500;
            color: #ff7700;
            background: linear-gradient(180deg, #ffffff 0%, #00dbff 100%);
            background-clip: text;
            // -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }

  }

  .machineListTip {
    margin-left: 6px;
    z-index: 1;
  }
}
</style>